import { LargeHeader } from '@shared/ui';

import { useProduct } from '@src/entities/products';

import ModalLarge from 'library/components/common/modals/ModalLarge';

import * as st from './styles.module.scss';

interface Props {
	id: number;
	isOpen: boolean;
	onClose: () => void;
}

export const PromoVideoModal: React.FC<Props> = ({ id, isOpen, onClose }: Props) => {
	const { product } = useProduct(id);
	return (
		<ModalLarge isOpen={isOpen} disableHeader onRequestClose={onClose}>
			<LargeHeader onClose={onClose} />
			<div className={st.wrapper}>
				<div className={st.embedContainer}>
					<iframe
						title="boomstream"
						src={`https://play.boomstream.com/${product?.product_video.code}?title=0`}
						allowFullScreen
					/>
				</div>
			</div>
		</ModalLarge>
	);
};
